import { z } from "zod/v4-mini"
import { OrderStatus, OrderSource, Status } from "../../db2/src/enums"

export { OrderStatus, OrderSource, Status }

export const placeOrderInput = z.object({
  addressId: z.number(),
  deliveryInstructions: z.optional(z.string()),
  items: z
    .array(
      z.object({
        productId: z.number(),
        quantity: z.number().check(z.positive()),
      }),
    )
    .check(z.minLength(1)),
})

export const updateOrderStatusInput = z.object({
  orderId: z.number(),
  status: z.enum(OrderStatus),
  rejectionReason: z.optional(z.string()),
})

export const getOrderInput = z.object({
  id: z.number(),
})

export const listOrdersInput = z.object({
  limit: z._default(z.optional(z.number()), 20),
  offset: z._default(z.optional(z.number()), 0),
})

// Admin schemas
export const listOrdersAdminInput = z.object({
  limit: z._default(z.optional(z.number()), 10),
  offset: z._default(z.optional(z.number()), 0),
  cursor: z.optional(z.number()),
  status: z.optional(z.array(z.enum(OrderStatus))),
  source: z.optional(z.array(z.enum(OrderSource))),
  orderNumber: z.optional(z.string()),
  customerId: z.optional(z.number()),
})

export const createOrderAdminInput = z.object({
  customerId: z.number(),
  addressId: z.number(),
  source: z.enum(OrderSource),
  items: z
    .array(
      z.object({
        productId: z.number(),
        quantity: z.number().check(z.positive()),
      }),
    )
    .check(z.minLength(1)),
  deliveryInstructions: z.optional(z.string()),
  discount: z._default(z.optional(z.number()), 0),
})

export const updateOrderInput = z.object({
  id: z.number(),
  items: z.optional(
    z.array(
      z.object({
        productId: z.number(),
        quantity: z.number().check(z.positive()),
      }),
    ),
  ),
  addressId: z.optional(z.number()),
  discount: z._default(z.optional(z.number()), 0),
})

export const updateOrderStatusAdminInput = z.object({
  id: z.number(),
  status: z.enum(OrderStatus),
  rejectionReason: z.optional(z.string()),
})
